function getCurrentTime(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;

    return strTime;
}

function sqlTimeToSystem(sqlTime){
    var timeSql = sqlTime;
    timeSql = timeSql.replace(/\.\d*/g, "").split(" ");
    //Date-Time to be separated by 'T' (capital T) ISO Standard 
    //Failing to do so will create issues with new Date() in IE
    timeSql = timeSql[0] + "T" + timeSql[1];

    return this.getCurrentTime(new Date(timeSql))
}

let TimeUtil = {
    getCurrentTime: getCurrentTime,
    sqlTimeToSystem: sqlTimeToSystem
}

export default TimeUtil;